<template>
  <div class="search-view">
    <div class="section">
      <div class="container-fluid">

        <div class="row">
          <div class="col-12 col-lg-4 col-xl-3">
            <div class="guide-article__top">
              <div class="guide-article__top-img">
                <img src="/assets/search.png" alt="Icon der Suchfunktion">
              </div>
              <div class="guide-article__top-info">
                <h2>Suche</h2>
                <h3 class="d-lg-none">Angebote, Veranstaltungen und noch viel mehr ...</h3>
                <h3 class="d-none d-lg-block">Angebote, Veranstaltungen und noch viel mehr ...</h3>
              </div>
            </div>
            <div class="mb30">
              <keyword-search :initialValue="searchWord" @searchWordChanged="searchWordChanged" />
            </div>

          </div>

          <div class="col-12 col-lg-8 col-xl-8 ml-auto main-content-section">

            <div v-show="numberOfResults == 0" class="search-content text-center">
              <div v-if="searchWord == ''" class="search-content text-center">
                <img src="/assets/search.png" alt="Search">
                <h5 class="mt20">Gib einen Suchbegriff ein.</h5>
              </div>
              <div v-else-if="showResults && numberOfResults == 0 && searchWord !== ''"
                class="search-content text-center">
                <img src="/assets/no-result.png" alt="Keine Suchergebnisse">
                <h5 class="mt20">Keine Ergebnisse für</h5>
                <h5>{{ `"` + searchWord + `"` }}</h5>
                <p class="mt20">Bitte gib einen anderen Suchbegriff ein.</p>
              </div>
            </div>

            <div v-show="numberOfResults > 0" class="search-results">
              <div class="container-fluid" v-if="showResults && searchWord !== ''">
                <content-section @numberOfResults="receiveNumberOfResults" title="Angebote" :searchWord="searchWord"
                  :contentId="parseInt($offerId)" :openInNewTab="true" />
                <content-section @numberOfResults="receiveNumberOfResults" title="Einrichtungen" :searchWord="searchWord"
                  :contentId="parseInt($institutionId)" :openInNewTab="true" />
                <content-section @numberOfResults="receiveNumberOfResults" title="Ratgeber" :searchWord="searchWord"
                  :contentId="parseInt($ratgeberId)" :openInNewTab="true" />
                <content-section @numberOfResults="receiveNumberOfResults" title="Schule" :searchWord="searchWord"
                  :contentId="parseInt($schulId)" :openInNewTab="true" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getContentsOfType } from '@/api/content';
import { showLoader, hideLoader, isset } from '@/utils/helpers';

export default {
  name: 'Suche',
  components: {
    ContentSection: () => import('./components/ContentSection.vue'),
    KeywordSearch: () => import('@/components/controls/KeywordSearch'),
  },
  data() {
    return {
      searchWord: '',
      showResults: false,
      awaitingSearch: false,
      numberOfResults: 0
    }
  },
  watch: {
    '$route.query.keyword': {
      handler: function (search) {
        this.searchWordChanged(search);
      },
      deep: true,
      immediate: true
    },
  },
  computed: {
    keyword() {
      return this.$route.query.keyword;
    },
  },
  methods: {
    showLoader,
    hideLoader,
    receiveNumberOfResults(number) {
      this.numberOfResults = this.numberOfResults + number;
    },
    searchWordChanged(word) {
      this.showResults = false;
      this.searchWord = word;
      if (!this.awaitingSearch) {
        setTimeout(() => {
          this.showResults = true;
          this.numberOfResults = 0;
          this.awaitingSearch = false;
        }, 1000);
      }
      this.awaitingSearch = true;
    },
  }
}
</script>
<style lang="scss" scoped>
@import '@/scss/_mixins.scss';
@import '@/scss/_variables.scss';


.search-view {
  margin-bottom: calc(#{$footer-sm-size} + #{$mobile-menu-size});

  @media (max-width: 991px) {
    margin-bottom: #{$mobile-menu-size}
  }

  .main-sidebar {
    margin-bottom: calc(#{$footer-sm-size} + #{$mobile-menu-size});
  }

  .guide-article__top-img {
    @media (max-width: 991px) {
      height: 150px;
      width: 150px;
    }

    @media (max-width: 660px) {
      min-width: 150px;
    }
  }

}
</style>